const actions = {
	toggle(context, id) {
		context.commit('TOGGLE', id);
	},
};

export default actions;



// WEBPACK FOOTER //
// ./scripts/sky-reveal/store/actions.js